module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/medium.f95acce485fc44f9a078.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/cosmos/medium.jpg
// module id = oetP
// module chunks = 24